import UnderDevelop from "../components/UnderDevelop";
import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import "../App.css";
import API from "../axios";


const Payslip = () => {


  const [showOtp, setShowOtp] = useState(false);
const [generatedOtp, setGeneratedOtp] =useState("");
const [enteredOtp, setEnteredOtp] = useState("");
const [downloadFiles, setDownloadFiles] = useState([]);
const [loading, setLoading] = useState(false);
  
  const empDetails = JSON.parse(localStorage.getItem("empDetails") || "{}");

    const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
const years = [2026, 2027, 2028, 2029, 2030];
  // Year State
  // const [year, setYear] = useState(
  //   currentYear >= 2026 && currentYear <= 2030 ? currentYear : 2026
  // );

  const [year, setYear] = useState(
  years.includes(currentYear) ? currentYear : 2026
);

  const [branch, setBranch] = useState(empDetails?.branchname);
  // const [empCode, setEmpCode] = useState(empDetails?.employee_code);

  const [empCode, setEmpCode] = useState(
  String(empDetails?.employee_code || "").padStart(4, "0")
);

  // Get current + previous 2 months
// Get previous 2 months + current month
const getRecentMonths = () => {

    const months = [];

    for (let i = 3; i > 0; i--) {

        const date = new Date();

        date.setMonth(
            currentDate.getMonth() - i
        );

        months.push({
            value: date.getMonth() - 1,

            label: date.toLocaleString(
                "default",
                {
                    month: "long"
                }
            )
        });
    }

    console.log(months);

    return months;
};

const monthOptions = getRecentMonths();

// No default selection
const [selectedMonths, setSelectedMonths] = useState([]);

  const handleMonthChange = (monthValue) => {
  if (selectedMonths.includes(monthValue)) {
    setSelectedMonths(
      selectedMonths.filter((m) => m !== monthValue)
    );
  } else {
    setSelectedMonths([...selectedMonths, monthValue]);
  }
};

const handleDownload = async () => {
  if (!year) {
    toast.error("Please select year", { autoClose: 2000 });
    return;
  }

  if (!branch || branch.trim() === "") {
    toast.error("Please enter branch", { autoClose: 2000 });
    return;
  }

  if (!empCode || empCode.trim() === "") {
    toast.error("Please enter employee code", { autoClose: 2000 });
    return;
  }

  if (selectedMonths.length === 0) {
    toast.error("Please select at least one month", {
      autoClose: 2000,
    });
    return;
  }

  setLoading(true);
  let downloadedMonths = [];
let notFoundMonths = [];

  let successCount = 0;
  let failedCount = 0;

  // try {
  //   for (const month of selectedMonths) {
  //     const fileUrl = `https://psmport.pothysswarnamahalapp.com/UploadedFiles/payslips/${year}/${branch}/${month}/${empCode}.pdf`;

  //     // const response = await fetch(fileUrl);

  //     const response = await API.post(
  //           "/download-payslip",
  //           {
  //               year,
  //               branch,
  //               month,
  //               empCode
  //           },
  //           {
  //               responseType: "blob"
  //           }
  //       );



  //     // if (!response.ok) {
  //     //   failedCount++;
  //     //   toast.error(`${month} payslip not found`, {
  //     //     autoClose: 2000,
  //     //   });
  //     //   continue;
  //     // }

  //   if (!response.ok) {
  //     notFoundMonths.push(month);
  //     continue;
  //   }

  //     const blob = await response.blob();
  //     const blobUrl = window.URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = blobUrl;
  //     link.download = `${empCode}_${month}_${year}.pdf`;

  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);

  //     window.URL.revokeObjectURL(blobUrl);

  //   downloadedMonths.push(month);
  //   }

  //     if (downloadedMonths.length > 0 && notFoundMonths.length > 0) {
  //         toast.success(
  //           `Downloaded: ${downloadedMonths.join(", ")}\nNot Found: ${notFoundMonths.join(", ")}`,
  //           {
  //             autoClose: 2000,
  //           }
  //         );
  //       } else if (downloadedMonths.length > 0) {
  //         toast.success(
  //           `Downloaded: ${downloadedMonths.join(", ")}`,
  //           {
  //             autoClose: 2000,
  //           }
  //         );
  //       } else {
  //         toast.error(
  //           `Payslip not found for: ${notFoundMonths.join(", ")}`,
  //           {
  //             autoClose: 2000,
  //           }
  //         );
  //       }

  //   setSelectedMonths([]);
  // } catch (error) {
  //   console.error(error);
  //   toast.error("Something Went Wrong, try agian later", {
  //     autoClose: 2000,
  //   });
  // }
  
for (const month of selectedMonths) {
    try {
        const response = await API.post(
            "/download-payslip",
            {
                year,
                branch,
                month,
                empCode
            },
            {
                responseType: "blob"
            }
        );

        const blob = new Blob(
            [response.data],
            { type: "application/pdf" }
        );

        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = `${empCode}_${month}_${year}.pdf`;

        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(blobUrl);

        downloadedMonths.push(month);

    setSelectedMonths([]);
    } catch (error) {

        if (error.response?.status === 404) {
            notFoundMonths.push(month);
        } else {
            console.error(error);
            notFoundMonths.push(month);
        }
    }
    finally{
      setLoading(false);
    }
}

// Toast messages after all downloads complete
if (downloadedMonths.length > 0 && notFoundMonths.length > 0) {

    toast.success(
        `Downloaded: ${downloadedMonths.join(", ")}`
    );

    toast.error(
        `Not Found: ${notFoundMonths.join(", ")}`
    );

} else if (downloadedMonths.length > 0) {

    toast.success(
        `Downloaded: ${downloadedMonths.join(", ")}`,
        {
            autoClose: 2000
        }
    );

} else {

    toast.error(
        `Payslip not found for: ${notFoundMonths.join(", ")}`,
        {
            autoClose: 2000
        }
    );
}
 
};



// const handleDownload = async () => {
//   if (!year) {
//     toast.error("Please select year", { autoClose: 2000 });
//     return;
//   }

//   if (!branch || branch.trim() === "") {
//     toast.error("Please enter branch", { autoClose: 2000 });
//     return;
//   }

//   if (!empCode || empCode.trim() === "") {
//     toast.error("Please enter employee code", { autoClose: 2000 });
//     return;
//   }

//   if (selectedMonths.length === 0) {
//     toast.error("Please select at least one month", {
//       autoClose: 2000,
//     });
//     return;
//   }

//   let allDownloaded = true;


//   const otp = Math.floor(100000 + Math.random() * 900000);

//   try {
//     for (const month of selectedMonths) {
//       const fileUrl = `https://psmport.pothysswarnamahalapp.com/UploadedFiles/payslips/${year}/${branch}/${month}/${empCode}.pdf`;

//       const response = await fetch(fileUrl);

//       if (!response.ok) {
//           allDownloaded = false;
//         toast.error(`${month} payslip not found`, {
//           autoClose: 2000,
//         });
//         continue;
//       }

//       const blob = await response.blob();
//       const blobUrl = window.URL.createObjectURL(blob);

//       const link = document.createElement("a");
//       link.href = blobUrl;
//       link.download = `${empCode}_${month}_${year}.pdf`;

//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       window.URL.revokeObjectURL(blobUrl);
//     }

//     if (allDownloaded) {
//       toast.success("Download completed", {
//         autoClose: 2000,
//       });
//     }

//     setSelectedMonths([]);
//   } catch (error) {
//     console.error(error);
//     toast.error("Error downloading payslip", {
//       autoClose: 2000,
//     });
//   }
// };




// const handleDownload = async () => {

//     if (!year) {
//         toast.error("Please select year");
//         return;
//     }

//     if (selectedMonths.length === 0) {
//         toast.error("Select month");
//         return;
//     }

//     setLoading(true);

//     let availableFiles = [];

//     for (const month of selectedMonths) {

//         const fileUrl = `https://psmport.pothysswarnamahalapp.com/UploadedFiles/payslips/${year}/${branch}/${month}/${empCode}.pdf`;

//         try {

//             const response = await fetch(fileUrl, {
//                 method: "HEAD"
//             });

//             if (response.ok) {

//                 availableFiles.push({
//                     month,
//                     url: fileUrl
//                 });

//             }

//         } catch (err) {}

//     }

//     setLoading(false);

//     if (availableFiles.length === 0) {

//         toast.error("No payslip available for selected month(s)");

//         return;

//     }

//     const otp = Math.floor(100000 + Math.random() * 900000);

//     setGeneratedOtp(otp.toString());

//     setDownloadFiles(availableFiles);

//     await sendWhatsappOtp(otp);

//     setShowOtp(true);

// };

// const sendWhatsappOtp = async (otp) => {

//     try {

//         await axios.post("YOUR_API_URL", {

//             mobile: empDetails.mobile_number,
//             otp: otp

//         });

//         toast.success("OTP sent successfully");

//     }
//     catch {

//         toast.error("Unable to send OTP");

//     }

// };

// const verifyOtp = async () => {

//     if (enteredOtp !== generatedOtp) {

//         toast.error("Invalid OTP");

//         return;

//     }

//     toast.success("OTP Verified");

//     for (const file of downloadFiles) {

//         const response = await fetch(file.url);

//         const blob = await response.blob();

//         const blobUrl = window.URL.createObjectURL(blob);

//         const link = document.createElement("a");

//         link.href = blobUrl;

//         link.download = `${empCode}_${file.month}_${year}.pdf`;

//         document.body.appendChild(link);

//         link.click();

//         document.body.removeChild(link);

//         window.URL.revokeObjectURL(blobUrl);

//     }

//     setShowOtp(false);

//     setEnteredOtp("");

//     setSelectedMonths([]);

// };


const sendOtp = async () => {
  const mobile = "9080450318";

 

 try {
  const response = await API.post("/send-otp", {
    mNumber: mobile
  });

  console.log(response.data);

  if (response.data.success) {
    alert(response.data.message);
  } else {
    alert(response.data.message);
  }
} catch (err) {
  console.error(err);

  if (err.response) {
    console.log(err.response.data);
  }
}
};

  return (
    <div>

      {/*
        empDetails.branchname.toLowerCase() === "corporate"
        ?
        <> */
            <div className="container py-lg-5 py-1">
      <div className="row justify-content-center">
        <div className="col-lg-6 col-md-8 col-sm-12">
          <div className="card shadow border-0 rounded-4">
            <div className="card-header text-center fw-bold rounded-top-4">
              <h4 className="mb-0">Payslip </h4>
            </div>

            <div className="card-body p-4 ">

              <div>
                 <label className="form-label fw-bold me-5">Emp Code : <small > {empDetails.employee_code}</small></label>
                 
                 <label className="form-label fw-bold">Branch : <small > {empDetails.branchname}</small></label>
              </div>
              
              <div className="mb-3">
                  {/* <label className="form-label fw-bold">Select Year</label> */}
                  <select
                    className="form-select"
                    value={year}
                    onChange={(e) => setYear(e.target.value)}
                  >
                    {years.map((yr) => (
                      <option
                        key={yr}
                        value={yr}
                        disabled={yr !== currentYear}
                      >
                        {yr}
                      </option>
                    ))}
                  </select>
                </div>


              {/* Branch */}
              {/* <div className="mb-3">
                <label className="form-label fw-bold">Branch</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Branch"
                  value={branch}
                  readOnly
                  onChange={(e) => setBranch(e.target.value)}
                />
              </div>


              <div className="mb-3">
                <label className="form-label fw-bold">
                  Employee Code
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Employee Code"
                  value={empCode}
                  readOnly
                  onChange={(e) => setEmpCode(e.target.value)}
                />
              </div> */}

              {/* Month Multi Select */}
              <div className="mb-4">
                <label className="form-label fw-bold">Months</label>

                <div className="border rounded p-3">
                  {monthOptions.map((month) => (
                    <div className="form-check" key={month.value}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={selectedMonths.includes(month.label)}
                        onChange={() =>
                          handleMonthChange(month.label)
                        }
                        id={`month-${month.label}`}
                      />

                      <label
                        className="form-check-label"
                        htmlFor={`month-${month.value}`}
                      >
                        {month.label}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

{
showOtp && (

<div className="card mt-3 border-primary">

    <div className="card-body">

        <label className="fw-bold">

            Enter OTP

        </label>

        <input

            type="text"

            className="form-control"

            value={enteredOtp}

            maxLength={6}

            onChange={(e)=>setEnteredOtp(e.target.value)}

        />

        <button

            className="btn btn-primary mt-3"

            // onClick={verifyOtp}

        >

            Verify OTP

        </button>

    </div>

</div>

)
}


 {/* <button

            className="btn btn-primary mt-3"

            onClick={sendOtp}

        >

            send OTP

        </button> */}


              {/* Download Button */}
              <div className="d-grid">
                {/*  <button
                  className="btn btn-success btn-sm rounded-3"
                  onClick={handleDownload}
                >
                  <i className="bi bi-download me-2"></i>
                  Download
                </button>
                */}
                <button
                    className="btn btn-primary"
                    onClick={handleDownload}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Downloading...
                      </>
                    ) : (
                      
                      "Download Payslip"
                    )}
                  </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
      /*  </>
        :
        <UnderDevelop/> 
      */} 
       

       {/* <ToastContainer
    position="bottom-right"
    autoClose={2000}
    hideProgressBar={false}
    newestOnTop
    closeOnClick
    pauseOnHover
    draggable
  /> */}
  <ToastContainer
    position="top-center"
    toastClassName="center-toast"
    bodyClassName="center-toast-body"
    autoClose={2000}
    hideProgressBar={false}
  />
    </div>
  );
};

export default Payslip;